import React from 'react';
import { FaSearch, FaCopy, FaDownload } from 'react-icons/fa';

const FilterPanel = ({ 
  filters, 
  setFilters, 
  handleCopyEmails, 
  handleExportEmails 
}) => {
  return (
    <div className="bg-gray-800 p-2 rounded-lg border border-gray-700 mb-6">
      <div className="flex flex-wrap items-end justify-end gap-3">
        <div className="flex-1 min-w-64">
          <label className="block text-xs font-medium text-gray-300 mb-1">Arama</label>
          <div className="relative">
            <FaSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 text-sm" />
            <input
              type="text"
              placeholder="Email, isim, uygulama ara..."
              className="w-full pl-10 pr-3 py-3 bg-gray-700 border border-gray-600 text-white rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
              value={filters.search}
              onChange={(e) => setFilters({...filters, search: e.target.value})}
            />
          </div>
        </div>
        
        <div className="flex-shrink-0">
          <label className="block text-xs font-medium text-gray-300 mb-1">Durum</label>
          <select
            className="w-full px-3 py-3 bg-gray-700 border border-gray-600 text-white rounded text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
            value={filters.status}
            onChange={(e) => setFilters({...filters, status: e.target.value})}
          >
            <option value="">Tüm Durumlar</option>
            <option value="pending">Bekliyor</option>
            <option value="contacted">Email Gönderildi</option>
            <option value="responded">Yanıtlandı</option>
            <option value="closed">Kapatıldı</option>
            <option value="unsubscribed">Unsubscribed</option>
          </select>
        </div>
        
        <div className="flex items-end space-x-2">
          <div>
            <label className="block text-xs font-medium text-gray-300 mb-1">&nbsp;</label>
            <button
              onClick={() => setFilters({status: '', search: ''})}
              className="px-3 py-3 bg-gray-600 text-white rounded text-sm hover:bg-gray-500 transition-colors"
            >
              Temizle
            </button>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-300 mb-1">&nbsp;</label>
            <button
              onClick={handleCopyEmails}
              className="px-4 py-3 bg-blue-600 text-white rounded text-sm hover:bg-blue-700 transition-colors flex items-center"
            >
              <FaCopy className="mr-2" />
              Copy
            </button>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-300 mb-1">&nbsp;</label>
            <button
              onClick={handleExportEmails}
              className="px-4 py-3 bg-green-600 text-white rounded text-sm hover:bg-green-700 transition-colors flex items-center"
            >
              <FaDownload className="mr-2" />
              Export
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
